import React from 'react';
type TricolorStripeProps = {
  className?: string;
};
export function TricolorStripe({
  className = 'h-1.5'
}: TricolorStripeProps) {
  return <div className={`grid w-full grid-cols-3 ${className}`} aria-hidden="true" data-id="element-109" data-mp="29p26fh3o8mog">
      <span className="bg-verde" data-id="element-110" data-mp="2en3smawe9245" />
      <span className="bg-paper" data-id="element-111" data-mp="2em11c1v5sxnp" />
      <span className="bg-salsa" data-id="element-112" data-mp="2jf3tq6o7a12b" />
    </div>;
}